import * as React from 'react';

// COMPONENTS
import Button from '../../components/Button';
import DisplayDragIcon from '../../components/DisplayDragIcon';

interface CheckListItemTypes {
	item: string;
	index: number;
	renderedChecklistItems: Array<string>;
	setRenderedChecklistItems: React.Dispatch<React.SetStateAction<string[]>>;
	removeHandler: (index: number) => void;
}

const CheckListItem: React.FC<CheckListItemTypes> = ({
	item,
	index,
	renderedChecklistItems,
	setRenderedChecklistItems,
	removeHandler
}) => {
	const [showError, setShowError] = React.useState<boolean>(false);

	const onChangeHandler = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
		const { value } = e.target;

		let newData = [...renderedChecklistItems];

		newData[index] = value;

		setRenderedChecklistItems(newData);

		if (value === '') {
			setShowError(true);
		} else {
			setShowError(false);
		}
	};

	return (
		<div className="checklist-item-wrapper">
			<div className="checklist-item-container">
				<div className="item-detail">
					<input className="item-input" type="text" value={item} onChange={(e) => onChangeHandler(e, index)} />
					<DisplayDragIcon index={index} array={renderedChecklistItems} />
				</div>

				<div className="button-container">
					<Button className="btn-text" onClick={() => removeHandler(index)}>
						Remove
					</Button>
				</div>
			</div>

			{showError && <div className="error-message">This field can not be blank</div>}
		</div>
	);
};

export default CheckListItem;
